import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RplStatusForm from '../../../components/forms/RplStatusForm';
import { useRplStatusById, useUpdateRplStatus } from '../../../hooks/useRplStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { RplStatusDTO } from '../../../services/apiClient';

const RplStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useRplStatusById(id!);
  const updateRplStatus = useUpdateRplStatus();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Rpl Statuses', href: '/admin/rplstatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateRplStatus.mutateAsync({ id: id!, data });
      navigate('/admin/rplstatuses');
    } catch (error) {
      console.error('Error updating RplStatus:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rplstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.RplStatus.Edit'
    >
        {entityData ? (
          <RplStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/rplstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default RplStatusEdit;